import React, { Component } from 'react';

import Navegacao from '../questoes/Navegacao';
import Questao from '../questoes/Questao';
import Loading from '../../Loading';
import ModalConfirm from '../../ModalConfirm';

import { STATUS_QUESTAO } from '../../../const';

class EtapaQuestoes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questoes: [],
            questaoAtual: 0
        }

        this.onClickProximaQuestao = this.onClickProximaQuestao.bind(this);
        this.onClickQuestaoAnterior = this.onClickQuestaoAnterior.bind(this);
        this.onClickProximaDuvida = this.onClickProximaDuvida.bind(this);
        this.onClickProximaEmBranco = this.onClickProximaEmBranco.bind(this);
        this.onClickConfirmar = this.onClickConfirmar.bind(this);
        this.onClickDuvida = this.onClickDuvida.bind(this);
        this.onChangeOpcao = this.onChangeOpcao.bind(this);
    }

    componentDidMount() {
        if (this.props.questoes.length > 0) {
            this.setState({ questoes: this.props.questoes });
        }
    }
    componentDidUpdate(prevProps) {
        // console.log('componentDidUpdate')
        // Don't forget to compare props, or you’ll cause an infinite loop
        if ((this.props.questoes.length !== prevProps.questoes.length)||(this.props.estudoFinalizado && this.props.questoes[this.state.questaoAtual] && this.state.questoes[this.state.questaoAtual] && this.props.questoes[this.state.questaoAtual].respostaCorreta !== this.state.questoes[this.state.questaoAtual].respostaCorreta)) {
            // console.log('update questoes')
            this.setState({ questoes: this.props.questoes });
        }
    }

    atualizarQuestao(questao, idx, callback) {
        var questoes = this.state.questoes;
        questoes[idx] = questao;

        this.setState({ questoes: questoes }, callback);
    }
    getQuestaoAtual() {
        if (this.state.questoes) {
            return this.state.questoes[this.state.questaoAtual] || {};
        }
        else {
            return {};
        }
    }
    getTotalQuestoes() {
        return (this.state.questoes || []).length;// || this.state.totalQuestoes;
        //return this.state.totalQuestoes;
    }
    getStatusQuestoes() {

        var arrStatus = [];
        var qtd = this.getTotalQuestoes();
        for (let index = 0; index < qtd; index++) {

            var status = STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO;

            const questao = this.state.questoes[index];
            if (questao) {
                status = questao.status;
            }

            arrStatus.push(status);
        }
        return arrStatus;
    }

    getQuestoesStatus(status) {
        var questoes = (this.state.questoes || []).filter(f => f.status === status);
        return questoes;
    }

    getQtdQuestoesEmBranco() {
        //Não é possivel filtrar as questões por tipo em branco, pois algumas questões podem ainda nem terem sido buscadas no servidor,
        //por isso a lógica deve ser baseada no valor total
        var qtdQuestoesRespondidas = this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA).length;
        var qtdQuestoesDuvida = this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length;
        var qtdQuestoesBranco = this.getTotalQuestoes() - qtdQuestoesDuvida - qtdQuestoesRespondidas;
        return qtdQuestoesBranco;
    }

    verificaTemQuestaoEmBranco() {
        var resultado = this.getTotalQuestoes() > 1 && this.getStatusQuestoes().indexOf(STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO) !== -1;
        return resultado;
    }
    verificaTemQuestaoDuvida() {

        var resultado = this.getTotalQuestoes() > 1 && this.getStatusQuestoes().indexOf(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA) !== -1;
        return resultado;
    }
    irProximaQuestaoComStatus(status) {

        //Tenta encontrar a proxima questão com o Status especificado a partir da questão atual
        var idx = this.getStatusQuestoes().indexOf(status, this.state.questaoAtual + 1);
        if (idx !== -1) {
            //this.setState({ questaoAtual: idx });
            this.popularQuestao(idx);
            return true;
        }
        else {
            //Se não encontrou nenhuma a partir da questão atual, tenta encontrar des do início das questões
            idx = this.getStatusQuestoes().indexOf(status, 0);
            if (idx !== -1) {
                this.popularQuestao(idx);
                return true;
            }
        }
        return false;
    }
    onClickProximaQuestao() {
        if (this.state.questaoAtual + 1 < this.getTotalQuestoes()) {
            this.popularQuestao(this.state.questaoAtual + 1);
            window.scrollTo(0, 0);
            return true;
        }
        return false;
    }
    onClickQuestaoAnterior() {
        if (this.state.questaoAtual - 1 >= 0) {
            this.popularQuestao(this.state.questaoAtual - 1);
            window.scrollTo(0, 0);
        }
    }
    onClickProximaEmBranco() {
        this.irProximaQuestaoComStatus(STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO);
        window.scrollTo(0, 0);
    }
    onClickProximaDuvida() {
        this.irProximaQuestaoComStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA);
        window.scrollTo(0, 0);
    }
    onClickConfirmar(resp) {
        var questao = this.getQuestaoAtual();
        questao.resposta = resp;
        questao.status = STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA;

        this.atualizarQuestao(questao, this.state.questaoAtual);
        this.onClickProximaQuestao();
    }

    onClickDuvida(resp) {
        //var numeroQuestao = this.state.questaoAtual + 1;
        var questao = this.getQuestaoAtual();
        questao.status = STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA;

        this.atualizarQuestao(questao, this.state.questaoAtual, () => {

            if (this.props.onChangeRespostas) {
                var respostas = this.getRespostas();
                this.props.onChangeRespostas(respostas);
            }
        });

        this.onClickProximaQuestao();
    }
    onChangeOpcao(resp) {

        //var numeroQuestao = this.state.questaoAtual + 1;
        var questao = this.getQuestaoAtual();
        questao.resposta = resp;
        //Devido à interface e fluxo desta etapa, as respostas serão aplicadas e salvas na API conforme forem marcadas
        questao.status = STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA;

        this.atualizarQuestao(questao, this.state.questaoAtual, () => {

            if (this.props.onChangeRespostas) {
                var respostas = this.getRespostas();
                this.props.onChangeRespostas(respostas);
            }
        });
    }

    getRespostas() {
        var respostas = this.state.questoes.map(q => q.resposta);
        return respostas;
    }

    async popularQuestao(indexQuestao, naoCarregarProximaQuestao) {
        var result = false;

        if (indexQuestao >= this.getTotalQuestoes())
            return;

        this.setState({ questaoAtual: indexQuestao });
        result = true;

        return result;
    }

    getVerificarRespostaCorreta() {
        // console.log('this.props.estudoFinalizado',this.props.estudoFinalizado)
        if (!this.props.estudoFinalizado) { return undefined; }

        var q = this.getQuestaoAtual();
        return parseInt(q.resposta) === parseInt(q.respostaCorreta);
    }

    render() {
        // console.log('this.props.questoes',this.props.questoes)
        return (<div>
            {this.props.loading && <Loading />}

            {/* {!this.props.loading && this.props.questoesEnviadas && !this.props.estudoFinalizado && <div>
                <p className="edb-text-bold">Suas questões já foram enviadas!</p>
                <p>Por favor, avalie o conteúdo deste estudo para que você possa visualizar a correção das questões.</p>
            </div>} */}

            {/* {!this.props.loading && (!this.props.questoesEnviadas || this.props.estudoFinalizado) && <div> */}
            {!this.props.loading && <div>

                <div className="edb-large edb-text-bold edb-margin-bottom">
                    {this.props.estudoFinalizado && <span className="edb-margin-left"><i className="edb-xlarge adap-text-green far fa-check-circle" title="Estudo finalizado"></i></span>} Teste seu conhecimento
                </div>



                {this.getTotalQuestoes() > 1 && <Navegacao
                    className="edb-round adap-light-gray"
                    questaoAtual={this.state.questaoAtual + 1}
                    totalQuestoes={this.getTotalQuestoes()}
                    temQuestaoDuvida={this.verificaTemQuestaoDuvida()}
                    temQuestaoEmBranco={this.verificaTemQuestaoEmBranco()}
                    onClickProxima={this.onClickProximaQuestao}
                    onClickAnterior={this.onClickQuestaoAnterior}
                    onClickProximaDuvida={this.onClickProximaDuvida}
                    onClickProximaEmBranco={this.onClickProximaEmBranco}
                    resposta={this.getVerificarRespostaCorreta()}
                    esconderBtnDuvida={this.props.estudoFinalizado}
                    esconderBtnBranco={this.props.estudoFinalizado}
                />}

                {this.getTotalQuestoes() === 1 && <div>
                    {this.getVerificarRespostaCorreta() === true && <div>
                        <i className="fas fa-check edb-large adap-text-green"></i>
                        &nbsp;
        <span className="edb-large edb-text-bold adap-text-green">Resposta correta</span>
                    </div>}
                    {this.getVerificarRespostaCorreta() === false && <div>
                        <i className="fas fa-times edb-large adap-text-red"></i>
                        &nbsp;
        <span className="edb-large edb-text-bold adap-text-red">Resposta incorreta</span>
                    </div>}
                </div>}

                <Questao className="edb-margin-top edb-margin-bottom"
                    questao={this.getQuestaoAtual()}
                    numeroQuestao={this.state.questaoAtual + 1}
                    opcaoSelecionada={this.getQuestaoAtual().resposta}
                    esconderBtnConfirmar={true}
                    onClickDuvida={this.onClickDuvida}
                    esconderBtnDuvida={this.getTotalQuestoes() <= 1}
                    onChangeOpcao={this.onChangeOpcao}
                    somenteLeitura={this.props.estudoFinalizado || this.props.questoesEnviadas}
                />

                 {this.props.questoesEnviadas && !this.props.estudoFinalizado && <div className="edb-center edb-text-bold edb-padding">
                    Suas questões já foram finalizadas!
                </div>}

                <ModalConfirm isOpen={this.props.modalConfirmarFinalizarQuestoes}
                    style={{ width: "420px", marginTop: "40px" }}
                    title="Tem certeza que deseja finalizar as questões?"
                    content={<div>
                        <p>Uma vez finalizadas, você não poderá alterar as respostas.</p>

                        {/****** Quantidade de questões em branco ******/}
                        {this.getQtdQuestoesEmBranco() === 1 && <p>
                            Você ainda tem <span className="adap-text-red edb-text-bold">uma questão em branco</span>.
                    </p>}
                        {this.getQtdQuestoesEmBranco() > 1 && <p>
                            Você ainda tem <span className="adap-text-red edb-text-bold">{this.getQtdQuestoesEmBranco()} questões em branco</span>.
                    </p>}

                        {/****** Quantidade de questões em dúvida ******/}
                        {this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length === 1 && <p>
                            Você ainda tem <span className="adap-text-red edb-text-bold">uma questão marcada como dúvida</span>.
                    </p>}
                        {this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length > 1 && <p>
                            Você ainda tem <span className="adap-text-red edb-text-bold">{this.getQuestoesStatus(STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA).length} questões marcadas como dúvida</span>.
                    </p>}
                    </div>}

                    confirmText="Sim, quero finalizar as questões."
                    confirmLoadingText="Finalizando, por favor aguarde..."
                    onClickConfirm={this.props.onClickConfirmarFinalizarQuestoes}
                    loadingConfirm={this.props.loadingFinalizarQuestoes}
                    cancelText="Não, ainda preciso conferir"
                    onClickCancel={this.props.onCancelarFinalizarQuestoes}
                />

                <div id="image-zoom"></div>
            </div>}

            {(this.props.correcao || this.props.comentario) &&  <div>
                <label>Comentário sobre a atividade:</label>
                <textarea style={{ width: "100%", height: "150px", borderRadius: "5px" }}
                    value={this.props.comentario}
                    onChange={(event) => this.props.onChangeComentario(event.target.value)}
                    disabled={!this.props.correcao}>
                </textarea>
            </div>}
        </div>);
    }
}

export default EtapaQuestoes;